import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import { urlAssets } from '../../Constants'

// ✅ TEMPORAL flags (igual que ya tienes)
// import defaultFlag from '../../assets/flags/default.png'

// const flagsContext = require.context('../../assets/flags', false, /\.png$/)

// const getFlagSrc = (slug) => {
// 	if (!slug) return defaultFlag

// 	const safe = String(slug).trim().toLowerCase()
// 	const file = `./${safe}.png`

// 	try {
// 		return flagsContext(file)
// 	} catch {
// 		return defaultFlag
// 	}
// }

const GroupStageTeam = (props) => {
	const {
		direction,
		errors,
		goals,
		finished,
		marginTeamName,
		bgColor,
		matchNumber,
		paddingContainer,
		register,
		slug,
		team,
		teamId,
		teamName,
		completed,
	} = props

	const allowedKeys = [
		'ArrowLeft',
		'ArrowUp',
		'ArrowRight',
		'ArrowDown',
		'Backspace',
		'Delete',
		'Tab',
		'Home',
		'End',
	]

	const name = `match${matchNumber}${team}Goals`

	// 🔥 nombre del input contrario (Home ↔ Away)
	const siblingName =
		team === 'Home'
			? `match${matchNumber}AwayGoals`
			: `match${matchNumber}HomeGoals`

	const minValueAllowed = 0
	const maxValueAllowed = 99

	// const flagSrc = getFlagSrc(slug)

	return (
		<section className="col-6 px-0">
			<section
				className={`d-flex align-items-center justify-content-between shadow-sm ${direction} ${paddingContainer} match-rounded ${bgColor}`}>
				<article className={`d-flex align-items-center ${direction}`}>
					<img
						src={`${urlAssets}/img/flags/${slug}.png`}
						alt={teamName}
						onError={(e) => {
							e.currentTarget.onerror = null
							e.currentTarget.src = `${urlAssets}/img/flags/default.png`
						}}
						loading="lazy"
						width={37}
					/>
					<span className={`${marginTeamName} groupstage-team-name`}>
						{teamName}
					</span>
				</article>

				<article className="d-flex">
					<Form.Control
						type="hidden"
						{...register(`match${matchNumber}${team}`)}
						value={teamId}
					/>

					<Form.Control
						bsPrefix="-"
						className="form-control text-center input-score"
						name={name}
						type="number"
						placeholder="-"
						readOnly={completed}
						onKeyDown={(e) => {
							if (allowedKeys.includes(e.key)) return

							if (
								!/^[0-9]*$/.test(e.key) ||
								e.currentTarget.value.length + 1 > 2
							) {
								e.preventDefault()
							}
						}}
						min={minValueAllowed}
						max={maxValueAllowed}
						defaultValue={finished ? goals : ''}
						{...register(name, {
							valueAsNumber: true,

							// ✅ VALIDACIÓN INTELIGENTE
							validate: (value, formValues) => {
								const v = value
								const sibling = formValues?.[siblingName]

								const isEmpty =
									v === '' ||
									v === null ||
									typeof v === 'undefined'

								const siblingEmpty =
									sibling === '' ||
									sibling === null ||
									typeof sibling === 'undefined'

								// ✅ Ambos vacíos → OK
								if (isEmpty && siblingEmpty) return true

								// ❌ Uno sí y otro no → ERROR
								if (isEmpty !== siblingEmpty)
									return 'Debes completar ambos goles del partido'

								return true
							},

							pattern: {
								value: /^[0-9]*$/,
								message: 'El marcador debe ser numérico',
							},

							max: {
								value: 99,
								message:
									'El marcador debe ser hasta de dos cifras',
							},

							min: {
								value: 0,
								message:
									'El marcador debe ser mayor o igual a 0',
							},
						})}
					/>
				</article>
			</section>

			<article className="d-flex my-1">
				<span className="match-data text-danger">
					{errors?.[name]?.message}
				</span>
			</article>
		</section>
	)
}

export default GroupStageTeam

GroupStageTeam.propTypes = {
	direction: PropTypes.string.isRequired,
	goals: PropTypes.number,
	group: PropTypes.string,
	finished: PropTypes.bool.isRequired,
	marginTeamName: PropTypes.string.isRequired,
	matchNumber: PropTypes.number.isRequired,
	bgColor: PropTypes.string.isRequired,
	paddingContainer: PropTypes.string,
	slug: PropTypes.string.isRequired,
	team: PropTypes.string.isRequired,
	teamId: PropTypes.string.isRequired,
	teamName: PropTypes.string.isRequired,
	register: PropTypes.func.isRequired,
	errors: PropTypes.object.isRequired,
}
